import type { SnapshotEntity } from '../../core/run';

// Position d'affichage entre deux pas du coeur. Pas d'interpolation sans pas précédent, pour une entité qui meurt, ou sur une téléportation.
export function lerpEntity(prev: SnapshotEntity | undefined, cur: SnapshotEntity, alpha: number): { x: number; y: number } {
  if (!prev || cur.anim === 'die' || Math.hypot(cur.x - prev.x, cur.y - prev.y) > 200) return { x: cur.x, y: cur.y };
  return { x: prev.x + (cur.x - prev.x) * alpha, y: prev.y + (cur.y - prev.y) * alpha };
}
